import { render } from 'preact'
import { MinicartCarousel } from 'libs/searchspring/components/recommendations/MinicartCarousel'
import { parseJSON } from '@/components/helpers/utils'

export class MinicartCarouselElement extends HTMLElement {
  connectedCallback() {
    this.renderComponent()
  }

  disconnectedCallback() {
    render(null, this)
  }

  static get observedAttributes() {
    return [
      'profile',
      'product-id',
      'limit',
      'item-class',
      'product-card-settings',
      'data-dl-section-id',
      'title'
    ]
  }

  attributeChangedCallback() {
    if (this.isConnected) {
      this.renderComponent()
    }
  }

  renderComponent() {
    const profile = this.getAttribute('profile')
    const productId = this.getAttribute('product-id')
    const limit = parseInt(this.getAttribute('limit') || '4', 10)
    const itemClass = this.getAttribute('item-class') || ''
    const productCardSettings = parseJSON(this.getAttribute('product-card-settings') || '{}')
    const dataDlSectionId = this.getAttribute('data-dl-section-id')
    const title = this.getAttribute('title') || 'Popular Products'

    render(
      <MinicartCarousel
        profile={profile}
        productId={productId}
        limit={limit}
        className={itemClass}
        productCardSettings={productCardSettings}
        data-dl-section-id={dataDlSectionId}
        title={title}
      />,
      this
    )
  }
}
